import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  AUTH_PREFIX_PATH,
  UNAUTHENTICATED_ENTRY,
  REDIRECT_URL_KEY,
} from "configs/AppConfig";
import useLogin from "features/auth/login/store/useLogin";

const ProtectedRoute = () => {
  const storeLogin = useLogin();
  const { token } = useSelector((state) => state.auth);
  const location = useLocation();

  // console.log({ storeLogin });

  if (!storeLogin.user) {
    return (
      <Navigate
        to={`${AUTH_PREFIX_PATH}${UNAUTHENTICATED_ENTRY}?${REDIRECT_URL_KEY}=${location.pathname}`}
        replace
      />
    );
  }

  return <Outlet />;
};

export default ProtectedRoute;
